import { useAtom } from 'jotai';
import { useCallback } from 'react';
import { FieldPath, useForm, FormProvider } from 'react-hook-form';
import { FieldsPerPage } from '../../CompanyProfiles2/Summary/CompanyDetailsPanel';
import { CompanyListsOverviewPanel } from '../../CompanyProfiles2/Summary/CompanyListsOverviewPanel';
import { getCompanyListsFieldsFromSchema } from '../../CompanyProfiles2/Summary/useCompanyListsFields';
import { ICompanyViewModel } from '../../../view-models/company.view-model';
import { useLoadSelectedListOverviewFieldsFields } from './data-display-utils';
import { selectedListOverviewFieldsOrgState } from './DataDisplayState';
import { DisplayConfig, IDummySectionProps } from './DisplayConfig';
import { DummyCompanyId } from './DummyData';
import { useListOverviewConfigActions } from './useDataDisplayConfigActions';

export function CompanyListsOverviewConfig() {
  const { loaded } = useLoadSelectedListOverviewFieldsFields();
  const allFields = getCompanyListsFieldsFromSchema();
  const [selectedFields, setSelectedFields] = useAtom(selectedListOverviewFieldsOrgState);
  const { handleSave, handleReset } = useListOverviewConfigActions();
  const methods = useForm({});

  const renderDummySection = useCallback(
    ({ defaultPage, key }: IDummySectionProps) => {
      return (
        <FormProvider {...methods}>
          <CompanyListsOverviewPanel
            companyId={DummyCompanyId}
            editable={false}
            fieldsToShow={selectedFields as FieldPath<ICompanyViewModel>[]}
            key={key}
            defaultPage={defaultPage}
          />
        </FormProvider>
      );
    },
    [selectedFields, methods]
  );

  if (!loaded) {
    return null;
  }
  return (
    <DisplayConfig
      title='Company Overview'
      allFields={allFields}
      selectedFields={selectedFields}
      setSelectedFields={setSelectedFields}
      handleResetConfig={handleReset}
      handleSaveChanges={handleSave}
      fieldsPerPage={FieldsPerPage}
      renderDummySection={renderDummySection}
    />
  );
}
